/*eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import Cookies from 'js-cookie';

Vue.use(Vuex);

export default new Vuex.Store({
    state : {
        cart : {
            items : [],
            itemsDelay : [],
            sum : 0,
            discountSum : 0,
            hasIndividualPrice : false,
            nextDiscountByBasket : []
        },
        initialData : {},
        productsData : {},
        shops : [],
        cities : [],
        citiesId : [],
        catalogFilters: {},
        userData : {},
        recaptchaSiteKey : '',
        openedPopup : null,
        selectedCityId : Cookies.get('selectedCityId') || null,
        cartCount : 0,
        userType : 'physical',
        userLastOrderBonusesTimestamp : 0,
        bonusesPersent : 0,
        isBot : false,
        token: '',
        bonusesSumma : 0,
        deviceType : 'desktop',
        taraTotalPrice : Cookies.get('taraTotalPrice') || 0,
        bonusesUsed : Cookies.get('bonusesUsed') || 0,
        cartDeliverySum : +Cookies.get('cartDeliverySum') || 0,
        orderDeliverySum : +Cookies.get('orderDeliverySum') || 0,
        orderDeliverySumPrepay : +Cookies.get('orderDeliverySumPrepay') || 0,
        cartDeliverySumPrepay : +Cookies.get('cartDeliverySumPrepay') || 0,
        returnTareData : Cookies.getJSON('returnTareData') || [],
        serverTime : +(new Date()),
        timeOffset : 0,
        lastAddedToCartId : null,
        isServicesOrder : false,
        addedToCartForce : false,
        refererProductId : localStorage && localStorage.refererProductId ? localStorage.getItem('refererProductId') : 0,
        petPromoData : Cookies.getJSON('petPromoData') || { quantity : 0 },
        domainForCookies : false,
        discountTextBasket : ''
    },
    mutations : {
        saveProductIdInLocalStorage (state, productId) {
            state.refererProductId = productId;
            if (localStorage) {
                try {
                    localStorage.setItem('refererProductId', productId);
                } catch (e) {
                    console.log(e);
                }
            }
        },
        setShops (state, shops) {
            state.shops = shops;
        },
        setServicesOrder (state, isServices) {
            state.isServicesOrder = !!isServices;
        },
        setOpenedPopup (state, popup) {
            state.openedPopup = popup;
        },
        setLastAddedToCartId (state, lastAddedToCartId) {
            state.lastAddedToCartId = +lastAddedToCartId;
        },
        setAddedToCartForce (state, force) {
            state.addedToCartForce = !!force;
        },
        setRecaptchaSiteKey (state, recaptchaSiteKey) {
            state.recaptchaSiteKey = recaptchaSiteKey;
        },
        setUserType (state, userType) {
            state.userType = userType;
        },
        setUserData (state, userData) {
            state.userData = userData;
        },
        setIsBot (state, isBot) {
            state.isBot = !!isBot;
        },
        setServerTime (state, serverTime) {
            state.serverTime = +serverTime;
            state.timeOffset = +(new Date()) - +serverTime;
        },
        setUserLastOrderBonusesTimestamp (state, userLastOrderBonusesTimestamp) {
            state.userLastOrderBonusesTimestamp = +userLastOrderBonusesTimestamp;
        },
        setTaraTotalPrice (state, taraTotalPrice) {
            state.taraTotalPrice = +taraTotalPrice;
            Cookies.set('taraTotalPrice', state.taraTotalPrice);
        },
        setBonusesPersent (state, bonusesPersent) {
            state.bonusesPersent = +bonusesPersent;
        },
        setBonusesSumma (state, bonusesSumma) {
            state.bonusesSumma = +bonusesSumma;
        },
        setOrderDeliverySumPrepay (state, orderDeliverySumPrepay) {
            state.orderDeliverySumPrepay = orderDeliverySumPrepay;
            Cookies.set('orderDeliverySumPrepay', orderDeliverySumPrepay);
        },
        setOrderDeliverySum (state, orderDeliverySum) {
            state.orderDeliverySum = orderDeliverySum;
            Cookies.set('orderDeliverySum', orderDeliverySum);
        },
        setCartDeliverySumPrepay (state, cartDeliverySumPrepay) {
            state.cartDeliverySumPrepay = cartDeliverySumPrepay;
            Cookies.set('cartDeliverySumPrepay', cartDeliverySumPrepay);
        },
        setBonusesUsed (state, bonusesUsed) {
            state.bonusesUsed = bonusesUsed;
            Cookies.set('bonusesUsed', bonusesUsed);
        },
        setCartDeliverySum (state, cartDeliverySum) {
            state.cartDeliverySum = cartDeliverySum;
            Cookies.set('cartDeliverySum', cartDeliverySum);
        },
        setCartCount (state, count) {
            state.cartCount = count;
        },
        incCartCount (state) {
            state.cartCount++;
        },
        setCities (state, cities) {
            state.cities = cities;
        },
        setReturnTareData (state, data = []) {
            state.returnTareData = data;
            Cookies.remove('returnTareData');
            Cookies.set('returnTareData', data, {domain: this.domainForCookies});
            //Cookies.set('returnTareData', data);
        },
        addReturnTara (state, tara) {
            Store.commit('setReturnTareData', [ tara ]);
        },
        setCatalogFilter(state, options)
        {
            state.catalogFilters = options;
        },
        setSelectedCityId (state, options) {

            let cityId = false;
            if(options && options.cityId)
                {
                    cityId = options.cityId;
                }

            let reload = false;
            if(options && options.reload)
                {
                    reload = options.reload;
                }

            if (cityId) {
                //Cookies.set('selectedCityId', cityId, { expires: 30, });
                Cookies.set('selectedCityId', cityId, { expires: -1, });
                Cookies.set('selectedCityId', cityId, { expires: 30, domain: this.domainForCookies});
                if (state.selectedCityId && state.selectedCityId != cityId && reload===true) {
                    location.reload();
                }
                state.selectedCityId = cityId;
            }
        },
        setShopCitiesId (state, citiesId) {
            if (citiesId) {
                state.shopCitiesId = citiesId;
            }
        },
        setInitialData (state, initialData) {
            state.initialData = initialData;
        },
        setCartItems (state, items = []) {
            state.cart.items = items;
        },
        setCartItemsDelay (state, items = []) {
            state.cart.itemsDelay = items;
        },
        setNextDiscount (state, items = []) {
            state.cart.nextDiscountByBasket = items;
        },
        setHasIndividualPrice (state, data = false) {
            state.cart.hasIndividualPrice = data;
        },
        setCartTotalSum (state, sum = 0) {
            state.cart.sum = sum;
        },
        setCartDiscountSum (state, sum = 0) {
            state.cart.discountSum = sum;
        },
        discountTextBasket (state, text = 0) {
            state.discountTextBasket = text;
        },
        setTokenData (state, data) {
            state.token = data;
        },
        setProductsData (state, productsData) {
            for (var productId in productsData) {
                if (state.productsData[productId]) {
                    state.productsData[productId] = productsData[productId];
                }
                else {
                    Vue.set(state.productsData, productId, productsData[productId]);
                }
            }
        },
        setPetPromoData (state, data) {
            //Cookies.set('petPromoData', data);
            Cookies.remove('petPromoData');
            Cookies.set('petPromoData', data, {domain: this.domainForCookies});
            state.petPromoData = data;
        },
        clearPetPromoData (state) {
            Cookies.set('petPromoData', '', {expires: -1, domain: this.domainForCookies});
            state.petPromoData = {};
        },
    },
    actions : {
        setSelectedCityId ({ commit, state }, options) {

            let cityId = false;
            if(options && options.cityId)
                {
                    cityId = options.cityId;
                }

            let reload = false;
            if(options && options.reload)
                {
                    reload = options.reload;
                }

            if (cityId) {
                if (location.host == 'dev-l-w.xpager.ru') {
                    commit('setSelectedCityId', {cityId : cityId, reload :reload});
                }
                else {
                    let city = state.initialData.cities.find(c => c.ID == cityId) || {};
                    let domain = state.initialData.domains.find(o => o.NAME == city.NAME);

                    let hostParts = location.host.split('.');

                    if (domain && domain.CODE != location.host && hostParts[hostParts.length - 1] !== 'localhost' && hostParts[hostParts.length - 1] !== 'io' && reload===true) {
                        location.href = `${location.protocol}//${domain.CODE}${location.pathname}?cityId=${cityId}`;
                    }
                    else if (!domain && 'l-w.ru' !== location.host && hostParts[hostParts.length - 1] !== 'localhost' && hostParts[hostParts.length - 1] !== 'io' && reload===true)
                    {
                        location.href = `${location.protocol}//l-w.ru${location.pathname}?cityId=${cityId}`;
                    }
                    else {
                        commit('setSelectedCityId', {cityId : cityId, reload : reload});
                    }
                }
            }
        },
        loadInitData ({ commit, dispatch }) {

            let domain = location.hostname.split(".");
            let domainReturn = "." + domain[domain.length-2] + "." + domain[domain.length-1];
            this.domainForCookies = domainReturn;

            return new Promise(resolve => {
                fetch('/api/v1/init-data/').then(res => res.json()).then(res =>
                {
                    if (res.data) {
                        commit('setInitialData', res.data || {});
                        if (+res.data.selectedCityId) {
                            dispatch('setSelectedCityId', {cityId : +res.data.selectedCityId, reload : true});
                        }
                    }
                    if (res.cart) {
                        commit('setCartItems', res.cart.items);
                        commit('setCartItemsDelay', res.cart.itemsDelay);
                        commit('setCartTotalSum', res.cart.sum);
                        commit('setCartDiscountSum', res.cart.discountSum);
                        commit('setNextDiscount', res.nextDiscount);
                        commit('setHasIndividualPrice', res.cart.hasIndividualPrice);
                        if(res.discountTextBasket) {
                            commit('discountTextBasket', res.discountTextBasket);
                        }
                    }
                    resolve(res);
                });
            });
        },
        loadCartData ({ commit }) {
            return new Promise(resolve => {
                fetch('/api/v1/cart/')
                    .then(res => res.json())
                    .then(res => {
                        if (res) {
                            commit('setCartItems', res.items);
                            commit('setCartItemsDelay', res.itemsDelay);
                            commit('setCartTotalSum', res.sum);
                            commit('setCartDiscountSum', res.discountSum);
                            commit('setNextDiscount', res.nextDiscount);
                            commit('setHasIndividualPrice', res.hasIndividualPrice);
                            if(res.discountTextBasket) {
                                commit('discountTextBasket', res.discountTextBasket);
                            }
                        }
                        resolve(res);
                    });
            });
        },
        loadShops ({ commit }) {
            fetch('/api/v1/shops/')
                .then(res => res.json())
                .then(res => {
                    if (res) {
                        commit('setShops', res.items || []);
                    }
                });
        },
        clearCart ({ commit, dispatch }) {
            return new Promise(resolve => {
                fetch('/api/v1/cart/clear/', { method : 'POST', })
                    .then(res => res.json())
                    .then(result => {

                        if(result && result.mainbox){
                            for( let ind in result.mainbox ){
                                this.$root.sendMainBoxItem(result.mainbox[ind]);
                            }
                        }

                        dispatch('loadCartData');
                        resolve();
                    });
            });
        },
        setPetPromoData ({ commit }, data = {}) {
            commit('setPetPromoData', data);
        },
        clearPetPromo ({ commit }, data = {}) {
            commit('clearPetPromoData', data);
        },
        setToken ({ commit }, data = {}) {
            commit('setTokenData', data);
        },
        loadProductData ({ commit }, data = {}) {
            return new Promise(resolve => {
                if (!this.productsLoadData) {
                    this.productsLoadData = [];
                }
                this.productsLoadData.push(data);
                clearTimeout(this.loadProductDataTimeout);
                this.loadProductDataTimeout = setTimeout(()=>{
                    let data = new FormData();
                    for (var i = 0; i < this.productsLoadData.length; i++) {
                        data.append(`productId[${i}]`, this.productsLoadData[i].productId);
                    }
                    fetch('/api/v1/products/get-balance/', {
                            method : 'POST',
                            body : data,
                        })
                        .then(res => res.json())
                        .then(res => {
                            if (res.items) {
                                commit('setProductsData', res.items);
                                resolve(res);
                            }
                        });
                }, 1000);
            });
        },
    },
    getters: {
        getCatalogFilters(state) {
            return state.catalogFilters;
        },
        getCategoryCatalogFilter(state, getters) {
            for (const [key] of Object.entries(getters.getCatalogFilters)) {
                if(getters.getCatalogFilters[key].code === 'KATEGORIYA')
                {
                    return getters.getCatalogFilters[key];
                }
            }
            return false;
        },
    }
})